// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullScreenCallView__container-b8e294 {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: var(--addition-80);
  z-index: 0;
}

.FullScreenCallView__own-video-container-c1c04f {
  position: absolute;
  top: 8px;
  inset-inline-end: 8px;
}

.FullScreenCallView__central-toasts-container-d24c08 {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/FullScreenCallView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;AACF","sourcesContent":[".container {\n  width: 100vw;\n  height: 100vh;\n  position: relative;\n  background-color: var(--addition-80);\n  z-index: 0;\n}\n\n.own-video-container {\n  position: absolute;\n  top: 8px;\n  inset-inline-end: 8px;\n}\n\n.central-toasts-container {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FullScreenCallView__container-b8e294`,
	"own-video-container": `FullScreenCallView__own-video-container-c1c04f`,
	"ownVideoContainer": `FullScreenCallView__own-video-container-c1c04f`,
	"central-toasts-container": `FullScreenCallView__central-toasts-container-d24c08`,
	"centralToastsContainer": `FullScreenCallView__central-toasts-container-d24c08`
};
module.exports = ___CSS_LOADER_EXPORT___;
